import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 dark:from-slate-900 dark:to-slate-800 text-gray-900 dark:text-white">
      {/* Fixed Navbar */}
      <div className="fixed w-full z-50">
        <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      </div>

      {/* Space below Navbar */}
      <div className="pt-32 flex min-h-screen">  {/* Changed from pt-20 to pt-32 */}
        {/* Sidebar */}
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

        {/* Main content */}
         <main className="ml-0 md:ml-64 w-full p-4 overflow-auto min-h-screen">
          <Outlet />
        </main>
      </div>

      <Footer />
    </div>
  );
}
